import React, { Fragment } from "react";
import styled from "@emotion/styled";
import {
  TypographyT36,
  TypographyT48,
  TypographyT49,
  TypographyT50,
  TypographyT51,
} from "Components/Common/Typography/index";
import { Spacer } from "Components/Common/Spacer/index";
import {
  FlexWrapperT1,
  FlexWrapperT2,
} from "Components/Common/Wrapper/FlexWrapper";
const ModalCardT2 = (props) => {
  const { children, selectItemForMoreInformationPopup } = props;
  const containerNumber =
    selectItemForMoreInformationPopup.container_number || "-";
  const routesDetails = !!selectItemForMoreInformationPopup.events
    ? ` ${selectItemForMoreInformationPopup.events[0].name}
             -  ${
               selectItemForMoreInformationPopup.events[
                 selectItemForMoreInformationPopup.events.length - 1
               ].name
             }`
    : "-";
  return (
    <Fragment>
      <ModalCardT2Wrapper>
        <FlexWrapperT2>
          <FlexWrapperT1>
            <TypographyT48>Container No:</TypographyT48>
            <TypographyT49>{containerNumber}</TypographyT49>
          </FlexWrapperT1>
          <FlexWrapperT1>
            <TypographyT50>Route:</TypographyT50>
            <TypographyT51>{routesDetails}</TypographyT51>
          </FlexWrapperT1>
        </FlexWrapperT2>
        <Spacer spacing={"10px"} />
        {children}
      </ModalCardT2Wrapper>
    </Fragment>
  );
};

export default ModalCardT2;

const ModalCardT2Wrapper = styled.div`
  border-radius: 8px;
  background: #e3e9ff;
  padding: 16px;
`;
